import { UserAccountTypesEnum } from 'APIPackage/AuthModule/enums/UserAccountTypesEnum';
import { UserRoleEnum } from 'APIPackage/AuthModule/enums/UserRoleEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getUserInfo = (state: IRootState) => state.auth.user;
export const getUserRole = (state: IRootState) => state.auth.user?.roles[0];
export const getUserRoleSysName = (state: IRootState) => getUserRole(state)?.sysname;
export const getUserRoleIsAdmin = (state: IRootState) => getUserRoleSysName(state) === UserRoleEnum.ADMIN;
export const getUserRoleIsProsecutor = (state: IRootState) => getUserRoleSysName(state) === UserRoleEnum.PROSECUTOR;
export const getUserRoleIsSupervisor = (state: IRootState) => getUserRoleSysName(state) === UserRoleEnum.SUPERVISOR;
export const getUserRoleIsOmbudsman = (state: IRootState) => getUserRoleSysName(state) === UserRoleEnum.OMBUDSMAN;
export const getUserRoleIsSuperProsecutor = (state: IRootState) =>
  getUserRoleSysName(state) === UserRoleEnum.SUPERIOR_PROSECUTOR;
export const getUserRoleIsProsecutorOrSuperProsecutor = (state: IRootState) =>
  getUserRoleIsProsecutor(state) || getUserRoleIsSuperProsecutor(state);
export const getUserLogin = (state: IRootState) => state.auth.user?.userAccount.login;
export const getUserAccountType = (state: IRootState) => state.auth.user?.userAccount.accountType;
export const getUserAccountTypeIsInternal = (state: IRootState) =>
  state.auth.user?.userAccount.accountType === UserAccountTypesEnum.INTERNAL &&
  state.auth.user?.userAccount.login === 'supervisor';
export const getAuthError = (state: IRootState) => state.auth.error;
export const getAuthOrganizations = (state: IRootState) => state.auth.organizations;
export const getAuthStage = (state: IRootState) => state.auth.stage;
export const getAuthIsLoggedOut = (state: IRootState) => state.auth.isLoggedOut;
export const getUserRoleIsProsecutorOrSuperProsecutorOrOmbudsman = (state: IRootState) =>
  getUserRoleIsProsecutor(state) || getUserRoleIsSuperProsecutor(state) || getUserRoleIsOmbudsman(state);
export const getUserProfileIsTest = (state: IRootState) => !!state.auth.user?.userProfile?.isTestUser;
